import { render, staticRenderFns } from "./FeaturesPanel.vue?vue&type=template&id=045199e6&scoped=true&"
import script from "./FeaturesPanel.vue?vue&type=script&lang=js&"
export * from "./FeaturesPanel.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesPanel.vue?vue&type=style&index=0&id=045199e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045199e6",
  null
  
)

component.options.__file = "FeaturesPanel.vue"
export default component.exports